import React, { Component, Fragment } from 'react'
import Navbar from '../components/Navbar'

import chevronIcon from '../assets/iconic/chevron.svg'
import Container from '../views/Container'
import SignupView from '../views/SignupView'
import Context from '../models/Context'
import { ReactComponent as CrossIcon } from "../assets/cross.svg"

class SignupScreen extends Component {
  constructor (props) {
    super(props)

    this.renderNavbarHeaderLeft = this.renderNavbarHeaderLeft.bind(this)
    this.renderNavbarHeaderRight = this.renderNavbarHeaderRight.bind(this)
    this.onSignup = this.onSignup.bind(this)
    this.onBack = this.onBack.bind(this)
  }

  render () {
    return (
      <Context.Consumer>
        {(context) => {
          const {
            t,
            authService
          } = context
          const title = t('SCREENS.SIGNUP.TITLE')
          return (
            <div>
              <Navbar
                  title={title}
                  className="app__navbar"
                  renderHeaderLeft={this.renderNavbarHeaderLeft}
                  renderHeaderRight={this.renderNavbarHeaderRight}
              />
              <Container>
                <SignupView
                  t={t}
                  onLoginCTA={this.onLogin}
                  authService={authService}
                  onSignup={this.onSignup}
                />
              </Container>
            </div>
          )
        }}
      </Context.Consumer>
    )
  }

  onSignup () {
    const { history } = this.props
    history.push('/register-success/')
  }

  onBack () {
    const { history } = this.props
    history.push('/reports/')
  }

  renderNavbarHeaderLeft () {
    return (
      <Fragment>

          <button onClick={this.onBack}>
            <img data-src={chevronIcon} className="iconic w-8 h-8" data-direction="left" alt="back" />
          </button>

      </Fragment>
    )
  }

  renderNavbarHeaderRight() {
    const { t } = this.context

    return (
      <Fragment>
        {/* <button onClick={this.onBack} title={t('NAVBAR.TOOLTIP.BACK')} className="my-8 md:my-0 btn-icon-label-round text-white bg-red active:bg-red-darker w-full"> */}
        <button onClick={this.onBack} title={t('NAVBAR.TOOLTIP.BACK')} className="my-0 btn-icon-label-round text-white bg-red active:bg-red-darker w-full">
          {/* <CrossIcon className="fill-current text-white" /><span className="md:hidden whitespace-nowrap">{t('NAVBAR.NEW')}</span> */}
          <CrossIcon className="fill-current text-white" /><span className="hidden whitespace-nowrap">{t('NAVBAR.NEW')}</span>
        </button>
      </Fragment>
    )
  }
}

SignupScreen.contextType = Context

export default SignupScreen
